import React from 'react';
import { SectionContainer as Section } from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { marginToLeft, moduleStyle } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumPosition } from 'src/types/common/common';
const MarginToLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //const { disabled } = props;

  return (
    <Section {...sectionProps}>
      <Field name={[moduleStyle, marginToLeft]}>
        <Slider
          disabled={props.disabled}
          position={EnumPosition.left}
          title={getI18n('general.margintoLeftEdge')}
        />
      </Field>
    </Section>
  );
};
export default MarginToLeft;
